module.exports = "<p>\n  payment works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/payment/payment.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/payment/payment.component.html
// module chunks = main